module.exports = __webpack_public_path__ + "static/media/rafa-extra-1.3e6c30e6.png";